import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { IColorPalette, IUser, PitchNotation, RhythmSyllableType, SolfaAudioType, UserActionTypes } from "../models";
import editUser from "./editUser";

export const changeUserColors = (
    { target: { value: colors } }: { target: { value: string | number } },
    userColorPalettes?: IColorPalette[]
) => async (
    dispatch: Dispatch<UserActionTypes>,
    getState: () => IStateTree,
    api: AxiosInstance,
    ) => {
        await api.post("/solfa-colors", { colors });
        if (typeof colors === "number") {
            dispatch(editUser({ ...(getState().user as IUser), colors }));
        } else {
            dispatch(editUser({ ...(getState().user as IUser), colors: userColorPalettes!.find(({ _id }) => _id === colors) }));
        }
    };

export const changePitchNotation = ({ target: { value: pitchNotation } }: { target: { value: PitchNotation } }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
        await api.post("/pitch-notation", { pitchNotation });
        dispatch(editUser({ ...(getState().user as IUser), pitchNotation }));
    };
export const changeReversedToneset = ({ target: { checked: reversedToneset } }: { target: { checked: boolean } }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
        await api.post("/reversed-toneset", { reversedToneset });
        dispatch(editUser({ ...(getState().user as IUser), reversedToneset }));
    };

export const changeSolfaAudio = ({ target: { value: solfaAudio } }: { target: { value: SolfaAudioType } }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
        await api.post("/solfa-audio", { solfaAudio });
        dispatch(editUser({ ...(getState().user as IUser), solfaAudio }));
    };

export const changeSolfaKam = ({ target: { checked: solfaKam } }: { target: { checked: boolean } }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
        await api.post("/solfa-kam", { solfaKam });
        dispatch(editUser({ ...(getState().user as IUser), solfaKam }));
    };

export const changeRhythmSyllableType = ({ target: { value: rhythmSyllableType } }: { target: { value: RhythmSyllableType } }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
        await api.post("/rhythm-syllable-type", { rhythmSyllableType });
        dispatch(editUser({ ...(getState().user as IUser), rhythmSyllableType }));
    };

export const changeSolfaShort = ({ target: { checked: solfaShort } }: { target: { checked: boolean } }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
        await api.post("/solfa-short", { solfaShort });
        dispatch(editUser({ ...(getState().user as IUser), solfaShort }));
    };

export const changeStudentColors = (colors: number | IColorPalette) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, colors }, user.loggedIn || false));
    };

export const changeStudentPitchNotation = (pitchNotation: PitchNotation) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, pitchNotation }, user.loggedIn || false));
    };

export const changeStudentReversedToneset = (reversedToneset: boolean) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, reversedToneset }, user.loggedIn || false));
    };

export const changeStudentRhythmSyllableTypes = (rhythmSyllableType: RhythmSyllableType) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, rhythmSyllableType }, user.loggedIn || false));
    };

export const changeStudentSolfaShort = (solfaShort: boolean) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, solfaShort }, user.loggedIn || false));
    };

export const changeStudentSolfaAudio = (solfaAudio: SolfaAudioType) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, solfaAudio }, user.loggedIn || false));
    };

export const changeStudentSolfaKam = (solfaKam: boolean) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree) => {
        const user = getState().user as IUser;
        dispatch(editUser({ ...user, solfaKam }, user.loggedIn || false));
    };
